// constrain webgl
import {WEBGL} from "three/examples/jsm/WebGL";

import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js';

import * as THREE from 'three';

import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls';

if (!WEBGL.isWebGLAvailable()) {
    alert('Ci scusiamo, ma la tecnologia webgl non è compatibile con il tuo browser. Aggiorna il tuo motore di navigazione');
}

let camera, controls, scene, renderer;

init();

animate();

function init() {

    scene = new THREE.Scene();
    scene.background = new THREE.Color(0x000000);
    scene.fog = new THREE.FogExp2(0xcccccc, 0.002);

    renderer = new THREE.WebGLRenderer({
        canvas: document.getElementById('turing'),
        antialias: true,
    });
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(window.innerWidth, window.innerHeight);

    camera = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 1, 1000);
    camera.position.set(1, 2, 3);

    // controls

    controls = new OrbitControls(camera, renderer.domElement);
    controls.listenToKeyEvents(window); // optional

    //controls.addEventListener( 'change', render ); // call this only in static scenes (i.e., if there is no animation loop)

    controls.enableDamping = true; // an animation loop is required when either damping or auto-rotation are enabled
    controls.dampingFactor = 0.10;

    // controls.screenSpacePanning = false;

    controls.minDistance = 0.5;
    controls.maxDistance = 3;

    controls.maxPolarAngle = Math.PI / 2;

    // world
    const loader = new GLTFLoader();

    loader.load('/turing/realistic_interior.glb',
        function (gltf) {
            const root = gltf.scene
            root.scale.set(1, 0.8, 1.5)

            scene.add(gltf.scene);
        },
        xhr => console.log(xhr.loaded / xhr.total * 100 + '% load'),
        function (error) {

            console.log(error);
        });

    const dirLight1 = new THREE.DirectionalLight(0xffffff);
    dirLight1.position.set(1, 1, 1);
    scene.add(dirLight1);

    const dirLight2 = new THREE.DirectionalLight(0x002288);
    dirLight2.position.set(-1, -1, -1);
    scene.add(dirLight2);

    const ambientLight = new THREE.AmbientLight(0x222222);
    scene.add(ambientLight);

    //

    window.addEventListener('resize', onWindowResize);

}

function onWindowResize() {

    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();

    renderer.setSize(window.innerWidth, window.innerHeight);

}

function animate() {

    requestAnimationFrame(animate);

    controls.update(); // only required if controls.enableDamping = true, or if controls.autoRotate = true

    render();

}

function render() {

    renderer.render(scene, camera);

}
